export default __webpack_public_path__ + "static/media/TechCrunch.1abaf8a9.svg";